<template>
  <div>
    <template v-if="!loading && contact.workOwner == 965">
      <div class="wg-col wg-xs-12 wg-sm-12 item">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Qualifica del contatto', 'Qualifica del contatto') }}</div>
          <select class="input-elem com-anm22-app-select" v-model="contactPricing.contactQualification">
            <option value>Nessuna qualifica</option>
            <option
              v-for="(qualification,index) in contactQualifications"
              :key="'contact-qual-'+index"
              :value="qualification.id"
            >{{qualification.description}}</option>
          </select>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <!--DATA -->
      <div class="wg-col wg-xs-12 wg-sm-12 item">
        <div
          class="com-anm22-app-text-m"
          style="font-size:18px;"
        >{{ $anm22.strLang(lang, 'Condizioni contrattuali', 'Condizioni contrattuali') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div
          class="com-anm22-app-text-m"
        >{{ $anm22.strLang(lang, 'Sconti / Commissioni accordati', 'Sconti / Commissioni accordati') }}</div>
        <textarea
          v-model="contactPricing.discount"
          class="input-elem com-anm22-app-textarea"
          style="height:100px;width:100%;max-width:unset;"
        ></textarea>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-12 item">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Scadenza contratti', 'Scadenza contratti') }}</div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            v-model="expirationDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div class="vertical-height-div" style="height:2px;"></div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-12 item">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Pagamenti particolari accordati', 'Pagamenti particolari accordati') }}</div>
          <textarea
            v-model="contactPricing.paymentsAccorded"
            class="input-elem com-anm22-app-textarea"
            style="height:100px;width:100%;max-width:unset;"
          ></textarea>
        </div>
      </div>
      <div class="wg-row">
        <div
          class="com-anm22-app-text-m"
          style="font-size:18px;"
        >{{ $anm22.strLang(lang, 'Reference Agent', 'Agente di riferimento') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-col wg-xs-6 wg-sm-6 item">
          <wg-search
            :placeholder="$anm22.strLang(lang, 'Agent', 'Agente')"
            :url="'paglierani/searchAgentByName'"
            :clickFn="addAgent"
            :canAdd="false"
            :addFn="() => { showNewContactModal = true; }"
            :filters="searchFilters"
            :attachedData="{}"
            :debounceTime="2000"
          ></wg-search>
        </div>

        <!-- Agent (ContactsContact) -->
        <div class="wg-row">
          <div
            class="wg-row"
            style="align-items:center;"
            v-if="agent"
          >
            <img
              :src="$anm22.getContactIcon(agent, $store)"
              :title="$anm22.getContactName(agent, $store)"
              class="com-anm22-app-img-fixed-height-l com-anm22-round"
              style="margin-right:5px;"
            >
            <div>
              <div
                class="com-anm22-app-text-m"
                style="font-weight:bold;"
              >{{ $anm22.getContactName(agent, $store) }}</div>
              <div class="vertical-height-div" style="height:2px;"></div>
              <div
                v-if="!offline"
                class="display-flex"
                style="align-items:center;cursor:pointer;"
                @click="removeAgent(agent)"
              >
                <img
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('deleteRed')"
                >
                <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}</div>
              </div>
            </div>
            <a :href="'https://www.anm22.it/app/contacts-v/?id=' + agent.idContactsContact">
              <img
                :src="$anm22.icons.getWorldIcon('openApp')"
                :title="$anm22.strLang(lang, 'Open in Contacts', 'Apri in Contacts')"
                class="com-anm22-app-img-fixed-height-m"
                style="margin-left:20px;"
              >
            </a>
            <div class="vertical-height-div" style="height:10px;"></div>
          </div>
        </div>
      </div>
      <template v-if="contactPricing.referenceAgent && contactPricing.contactQualification !== 'sub'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div
            class="com-anm22-app-text-m"
            style="font-size:18px;"
          >{{ $anm22.strLang(lang, 'Subagent', 'Subagente') }}</div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-col wg-xs-6 wg-sm-6 item">
            <select class="input-elem com-anm22-app-select" v-model="contactPricing.subagent">
              <option value>Nessun subagente</option>
              <option
                v-for="(agent,index) in contactsSubagents"
                :key="'agent-'+index"
                :value="agent.idContactsContact"
              >{{agent.firstName + ' ' + agent.lastName}}</option>
            </select>
          </div>
          <div class="wg-col wg-xs-6 wg-sm-6 item">
            <img
              v-if="contactPricing.subagent != 0 && $store.getters['contacts/get'](contactPricing.subagent) && (subagentPricing.contactQualification =='sub')"
              :src="$anm22.icons.getWorldIcon('openApp')"
              :title="$anm22.strLang(lang, 'Open contact', 'Apri contatto')"
              class="com-anm22-app-img-fixed-height-m"
              @click="$router.push({ path: `/contact/${contactPricing.subagent}` });"
              style="margin-left:20px;margin-top:5px;cursor:pointer;"
            />
          </div>
        </div>
      </template>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-12 item">
        <div
          class="com-anm22-app-text-m"
          style="font-size:18px;"
        >{{ $anm22.strLang(lang, 'Codice cliente', 'Codice cliente') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row input-row">
          <input
            v-model="contactPricing.clientCode"
            class="input-elem com-anm22-app-input-text"
            type="text"
          />
        </div>
      </div>
      <input
        type="button"
        class="small"
        :disabled="isSaving"
        :value="$anm22.strLang(lang, 'Save', 'Salva')"
        @click="saveData"
      />
    </template>
    <div v-else-if="contact.workOwner != 965" class="wg-row">
      <div
        class="com-anm22-app-text-m"
      >{{ $anm22.strLang(lang, 'Permission denied.', 'Non hai i permessi per accedere a questa tab.') }}</div>
    </div>
    <div class="vertical-height-div" style="height:47px;"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    contactId: [Number, String]
  },
  data() {
    return {
      isSaving:false,
     
      loading: false,
      contactQualifications: [
        {
          id: "clnt",
          description: "Cliente"
        },
        {
          id: "aEsclusivo",
          description: "Agente esclusivo"
        },
        {
          id: "aPprogetto",
          description: "Agente protezione progetto"
        },
        {
          id: "sub",
          description: "Subagente"
        },
        {
          id: "riv",
          description: "Rivenditore"
        },
        {
          id: "othrs",
          description: "Altro"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      offline: state => state.offline.isOffline,
      windowWidth: state => state.windowWidth
    }),
    contact() {
      return this.$store.getters["contacts/get"](this.contactId);
    },
    contacts() {
      return this.$store.getters["contacts/getAll"];
    },
    expirationDate: {
      get() {
        if (this.contactPricing.contractExpiration) {
          return this.$moment
            .unix(this.contactPricing.contractExpiration)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set(newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.contactPricing.contractExpiration = "";
        } else if (ts) {
          this.contactPricing.contractExpiration = ts;
        }
      }
    },
    contactPricing() {
      const contactPricing = this.$store.getters[
        "paglieraniContactPricing/getByContact"
      ](this.contact.idContactsContact);
      if (contactPricing) {
        return contactPricing;
      } else {
        return Object.assign({ referenceAgent: "", contactQualification: "" });
      }
    },
    agent() {
      if (this.contactPricing.referenceAgent != 0) {
        return this.$store.getters['contacts/get'](this.contactPricing.referenceAgent);
      }
    },
    agentPricing() {
      if (this.contactPricing.referenceAgent != 0) {
        return this.$store.getters["paglieraniContactPricing/getByContact"](
          this.contactPricing.referenceAgent
        );
      }
    },
    subagent() {
      if (this.contactPricing.subagent != 0) {
        return this.$store.getters['contacts/get'](this.contactPricing.subagent);
      }
    },
    subagentPricing() {
      if (this.contactPricing.subagent != 0) {
        return this.$store.getters["paglieraniContactPricing/getByContact"](
          this.contactPricing.subagent
        );
      }
    },
    allPricings() {
      return this.$store.getters["paglieraniContactPricing/getAll"];
    },
    pricingByAgentQualifications() {
      return this.allPricings.filter(
        p =>
          this.$store.getters["contacts/get"](p.contact) != undefined &&
          p.contact != this.contact.idContactsContact &&
          (p.contactQualification == "aEsclusivo" ||
            p.contactQualification == "aPprogetto")
      );
    },
    contactsAgents() {
      return this.pricingByAgentQualifications
        .map(p => this.$store.getters["contacts/get"](p.contact))
        .filter(
          (contact, index, arrayResult) =>
            arrayResult.findIndex(
              r => r.idContactsContact === contact.idContactsContact
            ) === index
        );
    },
    pricingBySubagentQualifications() {
      return this.allPricings.filter(
        p =>
          this.$store.getters["contacts/get"](p.contact) != undefined &&
          p.contact != this.contact.idContactsContact &&
          p.contactQualification == "sub" &&
          p.referenceAgent == this.agentPricing.contact
      );
    },
    contactsSubagents() {
      return this.pricingBySubagentQualifications
        .map(p => this.$store.getters["contacts/get"](p.contact))
        .filter(
          (contact, index, arrayResult) =>
            arrayResult.findIndex(
              r => r.idContactsContact === contact.idContactsContact
            ) === index
        );
    }
  },
  methods: {
    addAgent(contactId) {
      this.contactPricing.referenceAgent = contactId;
    },
    removeAgent() {
      this.contactPricing.referenceAgent = 0;
    },
    addSubagent(contactId) {
      this.contactPricing.subagent = contactId;
    },
    removeSubagent() {
      this.contactPricing.subagent = 0;
    },
    saveData() {
      this.isSaving = true;
      if (!this.contactPricing.idPaglieraniContactPricing) {
        this.newContactPricing();
      } else {
        this.editContactPricing();
      }
    },
    showMessage() {
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Saved",
          "Salvataggio avvenuto con successo"
        ),
        type: "suggestion"
      });
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    loadData() {
      Promise.all([
        this.$store.dispatch(
          "paglieraniContactPricing/load",
          this.$vlf("paglieraniContactPricing")
        )
      ]).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },
    newContactPricing() {
      this.$http
        .post("paglierani/newcontactpricing", {
          contactId: this.contact.idContactsContact,
          contactPricing: this.contactPricing
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("paglieraniContactPricing/update", {
            vlf: this.$vlf("paglieraniContactPricing"),
            objs: [response.data.contactPricing]
          });
        })
        .then(() => {
          this.showMessage();
          this.isSaving = false;
        })
        .catch(error => {});
    },
    editContactPricing() {
      this.$http
        .post("paglierani/editcontactpricing", {
          contactPricing: this.contactPricing
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("paglieraniContactPricing/update", {
            vlf: this.$vlf("paglieraniContactPricing"),
            objs: [response.data.contactPricing]
          });
        })
        .then(() => {
          this.showMessage();
           this.isSaving = false;
        })
        .catch(error => {});
    }
  },
  created() {
    if (this.contact.workOwner == 965) {
      this.loading = true;
      this.loadData();
      this.$http
        .get("paglierani")
        .then(response => {
          this.$store
            .dispatch("paglieraniContactPricing/update", {
              vlf: this.$vlf("paglieraniContactPricing"),
              objs: response.data.contactPricing,
              cleanFilters: []
            })
            .then(() => {
              this.$Progress.finish();
              this.loading = false;
            });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  margin-bottom: 10px;
}
</style>
